import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { UIManager } from "../UIManager";

export abstract class Caption {
    /**
     * Vytvoří label elementy pro všechny vnořené elementy s [data-captionlockey]
     * @param rootElement Kořenový element, ve kterém se vyhledává
     */
    public static createCaptionsForElements(rootElement: Element, locKeySelector: string = "[data-captionlockey]:not([data-ignorecaption])"): void {
        const captionElements = rootElement.querySelectorAll(locKeySelector);

        for (const captionElement of captionElements) {
            const caption = this._createCaptionElement(captionElement.id, captionElement.getAttribute("data-captionLocKey"), captionElement.hasAttribute("data-required"));
            captionElement.insertAdjacentElement("beforebegin", caption);
        }
    }

    /**
     * Vytvoří label přiřazený přes for="id" k vnitřnímu elementu, v html stromu bude ale sourozencem obalujícího
     * @param captionElement obalující element, potomek musí mít data-captionlockey
     */
    public static createCaptionForFirstChild(captionElement: Element): void {
        const fChild = captionElement.firstElementChild;
        if (!fChild)
            return;
        if (!fChild.id)
            fChild.id = UIManager.instance.generateElementID();

        const locKey = captionElement.getAttribute("data-captionLocKey");
        const caption = this._createCaptionElement(fChild.id, locKey, captionElement.hasAttribute("data-required"));

        captionElement.insertAdjacentElement("beforebegin", caption);
    }

    private static _createCaptionElement(forId: string, locKey: string, required: boolean): HTMLLabelElement {
        const classes = ["Caption"];
        if (required)
            classes.push("Required");

        const label = createElement({ type: "label", classes: classes, id: forId + "-label", attrs: { for: forId } }) as HTMLLabelElement;
        if (locKey)
            Localization.addLocTxtData(label, locKey);

        return label;
    }
}
